const locale = {
  placeholder: 'Please select',
  searchPlaceholder: 'Search',
  // FunctionSelectField
  functionPlaceholder: 'Please select function',
  functionSearchPlaceholder: 'Search function',
  // IndustrySelectField
  industryPlaceholder: 'Please select industry',
  industrySearchPlaceholder: 'Search industry',
  // AddressSelectField
  addressPlaceholder: 'Please select city',
  addressSearchPlaceholder: 'Search city',
  domestic: 'Domestic',
  abroad: 'Abroad'
};

export default locale;
